'use strict';

require('../../styles/fallbacks/grid.pcss');